import React from "react";
import {GoThumbsdown, GoThumbsup} from "react-icons/go";
import {useTranslation} from "react-i18next";

function Page4({ getResult }) {
    const { t, i18n } = useTranslation();
    const res = getResult()
    return (
        <div className="exam-sim-page-11">
            <div className="exam-sim-row">
                <div className="exam-sim-col">
                    {res.result ? <div className="exam-sim-result passed">
                        <GoThumbsup />
                        <h1>{t('sim.page4.passed')}</h1>
                    </div> : <div className="exam-sim-result failed">
                        <GoThumbsdown />
                        <h1>{t('sim.page4.failed')}</h1>
                    </div>}
                </div>
                <div className="exam-sim-col">
                    <ul className="exam-sim-result-list">
                        <li>
                            <div className={(res.result ? 'passed' : 'failed') + ' item'}>
                                <div>
                                    <h3>{t('sim.page4.result')}</h3>
                                    <div>{t('sim.page4.questionCount', { completed: res.correct, count: res.total })}</div>
                                    {!res.result && <span>{t('sim.page4.required', { count: res.min - res.correct })}</span>}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
export default Page4;
